import {Box, Divider, Grid} from '@material-ui/core'
import {LabelM0} from 'app/modules/Proposals/pages/NewProposal/City/Details/styles'
import {_} from 'i18n'
import {useSnackbar} from 'notistack'
import React from 'react'
import {Button, Form} from 'react-bootstrap'
import InputMask from 'react-input-mask'

import {Container, Title} from '../styles'

const Contact = ({
  street_name,
  street_type,
  street_number,
  subunit,
  city,
  state,
  postal_code,
  district,
  info: {contacts},

  handleChange,
  searchZip,
  onSubmit,
  submiting,
}) => {
  const {enqueueSnackbar} = useSnackbar()

  const isValid = () => {
    if (!contacts[0]?.name) {
      return true
    }

    if (!contacts[0]?.responsibility || !contacts[0]?.email || !contacts[0]?.mobile_phone) {
      enqueueSnackbar(_`Preencha os seguintes dados: Nome, Cargo, Email e Celular`, {
        variant: 'error',
      })

      return false
    }

    return true
  }

  return (
    <Container style={{padding: 0}}>
      <Grid container spacing={3}>
        <Grid item lg={3}>
          {' '}
        </Grid>
        <Grid item lg={9}>
          <Box marginBottom="20px">
            <Title>{_`CONTATO PRINCIPAL`}</Title>
          </Box>
        </Grid>

        <Grid item lg={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
          <LabelM0 htmlFor="company_contact_name">{_`Contato direto`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <Form.Control
            autoComplete="off"
            name="company_contact_name"
            id="company_contact_name"
            type="text"
            required
            value={contacts[0]?.name}
            onChange={handleChange}
            style={{maxWidth: 600}}
          />
        </Grid>

        <Grid item lg={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
          <LabelM0 htmlFor="company_contact_responsibility">{_`Cargo/função`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <Form.Control
            autoComplete="off"
            name="company_contact_responsibility"
            id="company_contact_responsibility"
            type="text"
            required
            value={contacts[0]?.responsibility}
            onChange={handleChange}
            style={{maxWidth: 600}}
          />
        </Grid>

        <Grid item lg={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
          <LabelM0 htmlFor="company_contact_phone">{_`Telefone`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <InputMask
            autoComplete="off"
            className="form-control"
            name="company_contact_phone"
            value={contacts[0]?.phone}
            onChange={handleChange}
            required
            placeholder={_`(99) 9999 9999`}
            mask="(99) 9999 9999"
            style={{maxWidth: 200}}
          />
        </Grid>

        <Grid item lg={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
          <LabelM0 htmlFor="company_contact_mobile_phone">{_`Celular 1`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <InputMask
            autoComplete="off"
            className="form-control"
            name="company_contact_mobile_phone"
            value={contacts[0]?.mobile_phone}
            onChange={handleChange}
            placeholder={_`(99) 99999 9999`}
            mask="(99) 99999 9999"
            style={{maxWidth: 200}}
          />
        </Grid>

        <Grid item lg={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
          <LabelM0 htmlFor="company_contact_mobile_phone_2">{_`Celular 2`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <InputMask
            autoComplete="off"
            className="form-control"
            name="company_contact_mobile_phone_2"
            value={contacts[0]?.mobile_phone_2}
            onChange={handleChange}
            placeholder={_`(99) 99999 9999`}
            mask="(99) 99999 9999"
            style={{maxWidth: 200}}
          />
        </Grid>

        <Grid item lg={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
          <LabelM0 htmlFor="company_contact_email">{_`E-mail`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <Form.Control
            autoComplete="off"
            name="company_contact_email"
            id="company_contact_email"
            type="email"
            required
            value={contacts[0]?.email}
            onChange={handleChange}
            style={{maxWidth: 600}}
          />
        </Grid>

        <Grid item lg={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
          <LabelM0 htmlFor="company_contact_linkedin">{_`Site`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <Form.Control
            autoComplete="off"
            name="company_contact_linkedin"
            id="company_contact_linkedin"
            type="text"
            value={contacts[0]?.site}
            onChange={handleChange}
            style={{maxWidth: 600}}
          />
        </Grid>

        <Grid item lg={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}></Grid>
        <Grid item lg={9}>
          <Divider />
        </Grid>

        <Grid item lg={3}>
          {' '}
        </Grid>
        <Grid item lg={9}>
          <Box marginBottom="20px">
            <Title>{_`ENDEREÇO DA EMPRESA`}</Title>
          </Box>
        </Grid>

        <Grid
          item
          lg={3}
          style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', textAlign: 'right'}}>
          <LabelM0 htmlFor="company_address_postal_code">{_`CEP`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <InputMask
            autoComplete="off"
            className="form-control"
            name="company_address_postal_code"
            id="company_address_postal_code"
            value={postal_code}
            onChange={(ev) => {
              handleChange(ev)
              searchZip(ev.target.value)
            }}
            readOnly
            placeholder={_`99.999-999`}
            mask="99.999-999"
            style={{maxWidth: 135}}
          />
        </Grid>

        <Grid
          item
          lg={3}
          style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', textAlign: 'right'}}>
          <LabelM0 htmlFor="company_address_street">{_`Logradouro`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <Form.Control
            autoComplete="off"
            name="company_address_street"
            id="company_address_street"
            type="text"
            readOnly
            onChange={handleChange}
            value={street_name}
            placeholder={_`Ex.: Rua Arnaldo`}
            style={{maxWidth: 600}}
          />
        </Grid>

        <Grid
          item
          lg={3}
          style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', textAlign: 'right'}}>
          <LabelM0 htmlFor="company_address_street_number">{_`Número`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <Form.Control
            autoComplete="off"
            name="company_address_street_number"
            id="company_address_street_number"
            type="text"
            onChange={handleChange}
            value={street_number}
            placeholder=""
            readOnly
            style={{maxWidth: 100}}
          />
        </Grid>

        <Grid
          item
          lg={3}
          style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', textAlign: 'right'}}>
          <LabelM0 htmlFor="company_address_district">{_`Bairro`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <Form.Control
            autoComplete="off"
            name="company_address_district"
            id="company_address_district"
            type="text"
            onChange={handleChange}
            value={district}
            placeholder=""
            readOnly
            style={{maxWidth: 400}}
          />
        </Grid>

        <Grid
          item
          lg={3}
          style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', textAlign: 'right'}}>
          <LabelM0>{_`UF`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <LabelM0>{state}</LabelM0>
        </Grid>

        <Grid
          item
          lg={3}
          style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end', textAlign: 'right'}}>
          <LabelM0>{_`Município`}</LabelM0>
        </Grid>
        <Grid item lg={9}>
          <LabelM0>{city}</LabelM0>
        </Grid>

        <Grid item lg={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}></Grid>
        <Grid item lg={9}>
          <Divider />
        </Grid>

        <Grid item lg={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}></Grid>
        <Grid item lg={9}>
          <Box display="flex" marginTop="70px" marginBottom="70px">
            <Box mr="20px" style={{maxWidth: 300, width: '100%'}}>
              <Button
                variant="outline-primary"
                onClick={() => {
                  console.log(isValid())
                  if (isValid()) {
                    onSubmit(true)
                  }
                }}>
                {_`SALVAR E CONTINUAR EDIÇÃO`}
              </Button>
            </Box>
            <Box>
              <Button
                onClick={() => {
                  console.log(isValid())
                  if (isValid()) {
                    onSubmit(false)
                  }
                }}
                disabled={submiting}>
                {_`SALVAR E CONCLUIR EDIÇÃO`}
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Container>
  )
}

export default Contact
